import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

// Cliente para a API antiga (padrão)
const httpLink = createHttpLink({
  uri: process.env.REACT_APP_V4_GRAPHQL || 'http://localhost:4000/graphql',
});

// Cliente para a nova API de eventos
const httpLinkNew = createHttpLink({
  uri: process.env.REACT_APP_API_V4_ENDPOINT_GQL || 'http://localhost:4000/gql',
});

const authLink = setContext((_, { headers }) => {
  // Get the authentication token from local storage if it exists
  const token = localStorage.getItem('backoffice@confi');
  
  // Return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    }
  };
});

// Cliente Apollo para API antiga (padrão)
export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
    },
    query: {
      fetchPolicy: 'network-only',
    },
  },
});

// Cliente Apollo para nova API de eventos
export const apolloClientNew = new ApolloClient({
  link: authLink.concat(httpLinkNew),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
    },
    query: {
      fetchPolicy: 'network-only',
    },
  },
}); 